import { __cAuthService } from '@/services/client/__c.auth.service'
import { TVerifyOtpAuthParams } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useVerifyOtpAuthMutation = () => {
  return useMutation({
    mutationKey: ['verify-otp-auth'],
    mutationFn: async (body: TVerifyOtpAuthParams) =>
      __cAuthService.verifyOtpAuth(body),
  })
}
